export default (state) => ({
  Personalization: {
    user: {
      id: state.Personalization.user.id,
      attributes: {
        zip: state.Personalization.user.attributes.zip,
      },
    },
    campaignResponses: state.Personalization.campaignResponses,
  }
})
